import React, { memo } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { STOGarantBanner } from '../components/STOGarantBanner';
import { CheckIcon, CalendarIcon, MapPinIcon, ActivityIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export default function SpringHikingTrips() {
  const springImages = [{
    src: 'https://images.unsplash.com/photo-1591471683432-994a8f3354c4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    alt: 'Spring wildflowers in Zakynthos'
  }, {
    src: 'https://images.unsplash.com/photo-1602513850041-58e73ffd3a57?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=987&q=80',
    alt: 'Coastal view in Zakynthos'
  }, {
    src: 'https://images.unsplash.com/photo-1586861256632-52a3db3369be?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80',
    alt: 'Olive groves in Zakynthos'
  }, {
    src: 'https://images.unsplash.com/photo-1597520051247-7c333d694c7c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80',
    alt: 'Navagio Beach in Zakynthos'
  }];
  const floraImages = [{
    src: 'https://images.unsplash.com/photo-1554631995-7273a1d091fc?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80',
    alt: 'Wild orchids in Zakynthos'
  }, {
    src: 'https://images.unsplash.com/photo-1590607199580-c2aeece82853?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    alt: 'Mediterranean flora in spring'
  }, {
    src: 'https://images.unsplash.com/photo-1533038590840-1f704a4eb7af?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80',
    alt: 'Bougainvillea flowers in Greece'
  }, {
    src: 'https://images.unsplash.com/photo-1611145434336-2cca8148401d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    alt: 'Wild cyclamen flowers'
  }];
  // Daily itinerary images
  const dailyImages = [{
    src: 'https://images.unsplash.com/photo-1586861256632-52a3db3369be?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80',
    alt: 'Arrival in Zakynthos'
  }, {
    src: 'https://images.unsplash.com/photo-1529333166437-7750a6dd5a70?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1169&q=80',
    alt: 'North-east Zakynthos'
  }, {
    src: 'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    alt: 'North mountainous area'
  }, {
    src: 'https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=987&q=80',
    alt: 'Central mountainous area'
  }, {
    src: 'https://images.unsplash.com/photo-1602513850041-58e73ffd3a57?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=987&q=80',
    alt: 'North-west area'
  }, {
    src: 'https://images.unsplash.com/photo-1597520051247-7c333d694c7c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80',
    alt: 'South-east area'
  }, {
    src: 'https://images.unsplash.com/photo-1591470482780-40c1d410eb6e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80',
    alt: 'Zakynthos town'
  }, {
    src: 'https://images.unsplash.com/photo-1533105079780-92b9be482077?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80',
    alt: 'Last day in Zakynthos'
  }];
  // Function to scroll to section 5
  const scrollToPricingSection = () => {
    document.getElementById('pricing-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="flex flex-col min-h-screen w-full" data-id="element-742">
      <Header data-id="element-743" />
      <main className="flex-grow" data-id="element-744">
        {/* Section 1: Hero with Description Box */}
        <section className="relative w-full py-16 bg-gray-50" data-id="element-745">
          <div className="container mx-auto px-4" data-id="element-746">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-10 text-center" data-id="element-747">
              Zakynthos walking holiday in spring
            </h1>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 max-w-6xl mx-auto bg-white rounded-lg shadow-md overflow-hidden" data-id="element-748">
              <div className="lg:col-span-2 p-8" data-id="element-749">
                <div className="prose max-w-none" data-id="element-750">
                  <p className="text-lg text-gray-700 mb-6" data-id="element-751">
                    Explore Zakynthos on a guided spring hiking tour! Discover
                    stunning coastal trails, vibrant wildflowers, and charming
                    traditional villages on this unforgettable walking holiday.
                  </p>
                  <div className="my-6 border-t border-b border-gray-200 py-6" data-id="element-752">
                    <ul className="space-y-3" data-id="element-753">
                      <li className="flex items-start" data-id="element-754">
                        <CheckIcon size={20} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-755" />
                        <span className="text-gray-700" data-id="element-756">
                          Spring wildflower walks and scenic nature trails
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-757">
                        <CheckIcon size={20} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-758" />
                        <span className="text-gray-700" data-id="element-759">
                          Breathtaking Zakynthos coastal hikes and panoramic
                          views
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-760">
                        <CheckIcon size={20} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-761" />
                        <span className="text-gray-700" data-id="element-762">
                          Authentic local culture and delicious Greek cuisine
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div className="mt-6" data-id="element-763">
                    <p className="text-xl font-bold text-gray-800 mb-2" data-id="element-764">
                      8-day hiking trip from € 695,- per person
                    </p>
                    <p className="text-gray-600" data-id="element-765">
                      Including accommodation, breakfast, excursions, hikes with
                      local guide & transfer
                    </p>
                  </div>
                </div>
              </div>
              <div className="lg:col-span-1 bg-gray-50 p-8 flex flex-col justify-center" data-id="element-766">
                <div className="space-y-4" data-id="element-767">
                  <a href="/join" className="block text-center bg-teal-600 hover:bg-teal-700 text-white font-medium py-3 px-6 rounded-md transition duration-300" data-id="element-768">
                    Book Here
                  </a>
                  <button onClick={scrollToPricingSection} className="block text-center w-full border-2 border-teal-600 text-teal-600 hover:bg-teal-600 hover:text-white font-medium py-3 px-6 rounded-md transition duration-300" data-id="element-769">
                    Pricing and Information
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Section 2: This Trip in Short */}
        <section className="py-16 w-full" data-id="element-770">
          <div className="container mx-auto px-4" data-id="element-771">
            <div className="max-w-4xl mx-auto" data-id="element-772">
              <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center" data-id="element-773">
                This Trip in Short
              </h2>
              <p className="text-lg text-gray-700 mb-10 leading-relaxed" data-id="element-774">
                Zakynthos has an incredible number of flowers, plants and herbs
                in all possible scents and colours; a Mediterranean flora with
                varied species, depending on the composition of the soil and the
                difference in altitude. As soon as spring comes, flowering
                starts from the coastal areas. The most common flowers are
                bougainvilleas, cyclamen, irises, wild orchids and roses. This
                trip is all about the beautiful flora, with special focus on
                discovering the wild orchids along the hiking trails.
              </p>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8" data-id="element-775">
                {floraImages.map((image, index) => <div key={index} className="overflow-hidden rounded-lg" data-id="element-776">
                    <img src={image.src} alt={image.alt} className="w-full h-64 object-cover transition-transform duration-300 hover:scale-105" data-id="element-777" />
                  </div>)}
              </div>
            </div>
          </div>
        </section>
        {/* Section 3: Day to Day Program */}
        <section className="py-16 bg-gray-50 w-full" data-id="element-778">
          <div className="container mx-auto px-4" data-id="element-779">
            <div className="max-w-6xl mx-auto" data-id="element-780">
              <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center" data-id="element-781">
                Day to Day Program
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-782">
                {/* Day 1 */}
                <div className="bg-white rounded-lg shadow-sm overflow-hidden" data-id="element-783">
                  <div className="p-6" data-id="element-784">
                    <h3 className="text-xl font-bold text-gray-800 mb-3" data-id="element-785">
                      Day 1: Arrival
                    </h3>
                    <p className="text-gray-700" data-id="element-786">
                      Arrival in Zakynthos. We meet our guide who also takes us
                      to our hotel in Alykanas, on the east side of the island.
                      Here we stay the first four nights. The second half of the
                      week we stay in Kalamaki, in the south of the island to
                      also discover that part of Zakynthos.
                    </p>
                  </div>
                  <img src={dailyImages[0].src} alt={dailyImages[0].alt} className="w-full h-48 object-cover" data-id="element-787" />
                </div>
                {/* Day 2 */}
                <div className="bg-white rounded-lg shadow-sm overflow-hidden" data-id="element-788">
                  <div className="p-6" data-id="element-789">
                    <h3 className="text-xl font-bold text-gray-800 mb-3" data-id="element-790">
                      Day 2: North-east
                    </h3>
                    <p className="text-gray-700" data-id="element-791">
                      Pick up from the hotel, for a nice walk nearby, around the
                      village Ano Gerakari, located on mountain top.
                      <br data-id="element-792" />
                      <br data-id="element-793" />
                      Above the village is a church that is visible from all
                      around the area. The view from the church is absolutely
                      amazing - either the main ridge on Zakynthos, the bay of
                      Alikes or endless olive groves. Hike about 5 km.
                    </p>
                  </div>
                  <img src={dailyImages[1].src} alt={dailyImages[1].alt} className="w-full h-48 object-cover" data-id="element-794" />
                </div>
                {/* Day 3 */}
                <div className="bg-white rounded-lg shadow-sm overflow-hidden" data-id="element-795">
                  <div className="p-6" data-id="element-796">
                    <h3 className="text-xl font-bold text-gray-800 mb-3" data-id="element-797">
                      Day 3: The north mountainous area
                    </h3>
                    <p className="text-gray-700" data-id="element-798">
                      We get to know the traditional life on Zakynthos. In
                      addition to tourism, the population of this fertile island
                      lives from the rich yields of agriculture.
                      <br data-id="element-799" />
                      <br data-id="element-800" />
                      We visit an olive press factory and a cheese factory,
                      where we also have lunch. We also visit an old monastery
                      in the mountains.
                    </p>
                  </div>
                  <img src={dailyImages[2].src} alt={dailyImages[2].alt} className="w-full h-48 object-cover" data-id="element-801" />
                </div>
                {/* Day 4 */}
                <div className="bg-white rounded-lg shadow-sm overflow-hidden" data-id="element-802">
                  <div className="p-6" data-id="element-803">
                    <h3 className="text-xl font-bold text-gray-800 mb-3" data-id="element-804">
                      Day 4: Central mountainous area
                    </h3>
                    <p className="text-gray-700" data-id="element-805">
                      Today we walk in the area of ​​Giri, one of the oldest and
                      highest villages on the island. It is located at an
                      altitude of 550 m above sea level, close to the mountain
                      Vrachionas, the highest point of Zakynthos (756 m).
                      <br data-id="element-806" />
                      <br data-id="element-807" />
                      On the way we visit the local Vertzageio museum, which
                      gives an insight into the former rural life.
                    </p>
                  </div>
                  <img src={dailyImages[3].src} alt={dailyImages[3].alt} className="w-full h-48 object-cover" data-id="element-808" />
                </div>
                {/* Day 5 */}
                <div className="bg-white rounded-lg shadow-sm overflow-hidden" data-id="element-809">
                  <div className="p-6" data-id="element-810">
                    <h3 className="text-xl font-bold text-gray-800 mb-3" data-id="element-811">
                      Day 5: North-west area
                    </h3>
                    <p className="text-gray-700" data-id="element-812">
                      A hike at the Keri area, ± 7 km. Keri is a charming,
                      authentic mountain village. Part of the houses date from
                      the period before the great earthquake of 1953. The
                      village has been restored in a traditional way.
                      <br data-id="element-813" />
                      <br data-id="element-814" />
                      Afterwards we walk to Marathia to enjoy the view and lunch
                      in local coffee place.
                    </p>
                  </div>
                  <img src={dailyImages[4].src} alt={dailyImages[4].alt} className="w-full h-48 object-cover" data-id="element-815" />
                </div>
                {/* Day 6 */}
                <div className="bg-white rounded-lg shadow-sm overflow-hidden" data-id="element-816">
                  <div className="p-6" data-id="element-817">
                    <h3 className="text-xl font-bold text-gray-800 mb-3" data-id="element-818">
                      Day 6: South-east area
                    </h3>
                    <p className="text-gray-700" data-id="element-819">
                      A hike at Gerakas (± 6 km), located on the Vassilikos
                      peninsula south of Zakynthos town. A beautiful sandy
                      beach, located in a semicircular bay and surrounded by
                      rock formations. This is one of the beaches where
                      Caretta-Caretta turtles come to lay their eggs.
                      <br data-id="element-820" />
                      <br data-id="element-821" />
                      Afternoon: Lunch in a tavern at Dafni beach.
                    </p>
                  </div>
                  <img src={dailyImages[5].src} alt={dailyImages[5].alt} className="w-full h-48 object-cover" data-id="element-822" />
                </div>
                {/* Day 7 */}
                <div className="bg-white rounded-lg shadow-sm overflow-hidden" data-id="element-823">
                  <div className="p-6" data-id="element-824">
                    <h3 className="text-xl font-bold text-gray-800 mb-3" data-id="element-825">
                      Day 7: Zakynthos town & sunset hike
                    </h3>
                    <p className="text-gray-700" data-id="element-826">
                      A visit to Zakynthos town in the morning. The city is a
                      bustling port town and rebuilt after a wildfire destroyed
                      everything that has been left by the earthquake in 1953.
                      We will visit some historical sights (churches, museum
                      etc.), can shop and walk around.
                      <br data-id="element-827" />
                      <br data-id="element-828" />
                      At the end of the afternoon we start the 'sunset hike'.
                    </p>
                  </div>
                  <img src={dailyImages[6].src} alt={dailyImages[6].alt} className="w-full h-48 object-cover" data-id="element-829" />
                </div>
                {/* Day 8 */}
                <div className="bg-white rounded-lg shadow-sm overflow-hidden" data-id="element-830">
                  <div className="p-6" data-id="element-831">
                    <h3 className="text-xl font-bold text-gray-800 mb-3" data-id="element-832">
                      Day 8: Optional & back home
                    </h3>
                    <p className="text-gray-700" data-id="element-833">
                      We can fill this day in our own way in consultation. For
                      example, a nice beach walk to nearby Alykes and take a dip
                      in the sea. Or rent a bike and explore the area around
                      Alikanas; quiet roads through olive groves and vineyards
                      and picturesque villages in this flat part of the island.
                    </p>
                  </div>
                  <img src={dailyImages[7].src} alt={dailyImages[7].alt} className="w-full h-48 object-cover" data-id="element-834" />
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Section 4: Accommodation and Facilities */}
        <section className="py-16 w-full" data-id="element-835">
          <div className="container mx-auto px-4" data-id="element-836">
            <div className="max-w-4xl mx-auto" data-id="element-837">
              <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center" data-id="element-838">
                Accommodation & Facilities
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-839">
                <div data-id="element-840">
                  <img src="https://images.unsplash.com/photo-1566073771259-6a8506099945?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80" alt="Comfortable accommodation in Zakynthos" className="w-full h-full object-cover rounded-lg" data-id="element-841" />
                </div>
                <div className="flex flex-col justify-center" data-id="element-842">
                  <h3 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-843">
                    Your Home in Zakynthos
                  </h3>
                  <p className="text-gray-700 mb-4" data-id="element-844">
                    During your spring hiking holiday, you'll stay in carefully
                    selected accommodations that offer comfort, character, and
                    authentic Greek hospitality. We choose small, family-run
                    hotels or guesthouses that provide a genuine local
                    experience.
                  </p>
                  <p className="text-gray-700" data-id="element-845">
                    All rooms have private bathrooms and essential amenities,
                    with properties located in scenic areas that serve as
                    perfect starting points for our daily hikes.
                  </p>
                </div>
              </div>
              <div className="bg-gray-50 p-8 rounded-lg" data-id="element-846">
                <h3 className="text-2xl font-bold text-gray-800 mb-6 text-center" data-id="element-847">
                  What's Included
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-848">
                  <div data-id="element-849">
                    <h4 className="font-bold text-gray-800 mb-3" data-id="element-850">
                      Accommodation
                    </h4>
                    <ul className="space-y-2" data-id="element-851">
                      <li className="flex items-start" data-id="element-852">
                        <CheckIcon size={18} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-853" />
                        <span className="text-gray-700" data-id="element-854">
                          7 nights in comfortable hotels/guesthouses
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-855">
                        <CheckIcon size={18} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-856" />
                        <span className="text-gray-700" data-id="element-857">
                          All rooms with private bathroom
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-858">
                        <CheckIcon size={18} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-859" />
                        <span className="text-gray-700" data-id="element-860">
                          Daily housekeeping
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div data-id="element-861">
                    <h4 className="font-bold text-gray-800 mb-3" data-id="element-862">Meals</h4>
                    <ul className="space-y-2" data-id="element-863">
                      <li className="flex items-start" data-id="element-864">
                        <CheckIcon size={18} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-865" />
                        <span className="text-gray-700" data-id="element-866">
                          Daily breakfast with local products
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-867">
                        <CheckIcon size={18} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-868" />
                        <span className="text-gray-700" data-id="element-869">
                          Welcome dinner on first night
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-870">
                        <CheckIcon size={18} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-871" />
                        <span className="text-gray-700" data-id="element-872">
                          Farewell dinner on last night
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div data-id="element-873">
                    <h4 className="font-bold text-gray-800 mb-3" data-id="element-874">
                      Transportation
                    </h4>
                    <ul className="space-y-2" data-id="element-875">
                      <li className="flex items-start" data-id="element-876">
                        <CheckIcon size={18} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-877" />
                        <span className="text-gray-700" data-id="element-878">
                          Airport transfers on arrival and departure
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-879">
                        <CheckIcon size={18} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-880" />
                        <span className="text-gray-700" data-id="element-881">
                          All necessary transfers to hiking trails
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div data-id="element-882">
                    <h4 className="font-bold text-gray-800 mb-3" data-id="element-883">Guidance</h4>
                    <ul className="space-y-2" data-id="element-884">
                      <li className="flex items-start" data-id="element-885">
                        <CheckIcon size={18} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-886" />
                        <span className="text-gray-700" data-id="element-887">
                          Experienced English-speaking local guide
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-888">
                        <CheckIcon size={18} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-889" />
                        <span className="text-gray-700" data-id="element-890">
                          Detailed route information
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-891">
                        <CheckIcon size={18} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-892" />
                        <span className="text-gray-700" data-id="element-893">
                          24/7 support during your stay
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Section 5: Pricing Information */}
        <section id="pricing-section" className="py-16 bg-gray-50 w-full" data-id="element-894">
          <div className="container mx-auto px-4" data-id="element-895">
            <div className="max-w-4xl mx-auto" data-id="element-896">
              <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center" data-id="element-897">
                Pricing & Information
              </h2>
              <div className="bg-white p-8 rounded-lg shadow-md mb-8" data-id="element-898">
                <h3 className="text-2xl font-bold text-gray-800 mb-6" data-id="element-899">
                  2025 Spring Dates
                </h3>
                <div className="space-y-6" data-id="element-900">
                  <div className="flex flex-col md:flex-row md:items-center justify-between pb-4 border-b border-gray-200" data-id="element-901">
                    <div className="flex items-center mb-3 md:mb-0" data-id="element-902">
                      <CalendarIcon size={20} className="text-teal-600 mr-3" data-id="element-903" />
                      <span className="font-medium" data-id="element-904">April 12 - 19, 2025</span>
                    </div>
                    <div className="flex items-center" data-id="element-905">
                      <span className="text-teal-600 font-bold text-lg mr-4" data-id="element-906">
                        € 695 per person
                      </span>
                      <span className="bg-green-100 text-green-800 text-xs font-medium px-2.5 py-0.5 rounded" data-id="element-907">
                        Available
                      </span>
                    </div>
                  </div>
                  <div className="flex flex-col md:flex-row md:items-center justify-between pb-4 border-b border-gray-200" data-id="element-908">
                    <div className="flex items-center mb-3 md:mb-0" data-id="element-909">
                      <CalendarIcon size={20} className="text-teal-600 mr-3" data-id="element-910" />
                      <span className="font-medium" data-id="element-911">May 3 - 10, 2025</span>
                    </div>
                    <div className="flex items-center" data-id="element-912">
                      <span className="text-teal-600 font-bold text-lg mr-4" data-id="element-913">
                        € 725 per person
                      </span>
                      <span className="bg-green-100 text-green-800 text-xs font-medium px-2.5 py-0.5 rounded" data-id="element-914">
                        Available
                      </span>
                    </div>
                  </div>
                  <div className="flex flex-col md:flex-row md:items-center justify-between pb-4 border-b border-gray-200" data-id="element-915">
                    <div className="flex items-center mb-3 md:mb-0" data-id="element-916">
                      <CalendarIcon size={20} className="text-teal-600 mr-3" data-id="element-917" />
                      <span className="font-medium" data-id="element-918">May 17 - 24, 2025</span>
                    </div>
                    <div className="flex items-center" data-id="element-919">
                      <span className="text-teal-600 font-bold text-lg mr-4" data-id="element-920">
                        € 725 per person
                      </span>
                      <span className="bg-yellow-100 text-yellow-800 text-xs font-medium px-2.5 py-0.5 rounded" data-id="element-921">
                        Limited Spots
                      </span>
                    </div>
                  </div>
                </div>
                <div className="mt-6 pt-6 border-t border-gray-200" data-id="element-922">
                  <h4 className="font-bold text-gray-800 mb-3" data-id="element-923">
                    Price Includes
                  </h4>
                  <ul className="space-y-2" data-id="element-924">
                    <li className="flex items-start" data-id="element-925">
                      <CheckIcon size={18} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-926" />
                      <span className="text-gray-700" data-id="element-927">
                        7 nights accommodation
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-928">
                      <CheckIcon size={18} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-929" />
                      <span className="text-gray-700" data-id="element-930">Daily breakfast</span>
                    </li>
                    <li className="flex items-start" data-id="element-931">
                      <CheckIcon size={18} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-932" />
                      <span className="text-gray-700" data-id="element-933">
                        Welcome and farewell dinners
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-934">
                      <CheckIcon size={18} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-935" />
                      <span className="text-gray-700" data-id="element-936">
                        Airport transfers and transportation to trails
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-937">
                      <CheckIcon size={18} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-938" />
                      <span className="text-gray-700" data-id="element-939">
                        Professional English-speaking guide
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="mt-8 text-center" data-id="element-940">
                <p className="text-gray-600 italic" data-id="element-941">
                  This offer is covered by the STO Garant guarantee. You can
                  find the conditions for this guarantee scheme on STO Garant's
                  website (www.sto-garant.nl/en/downloads).
                </p>
              </div>
            </div>
          </div>
        </section>
        <STOGarantBanner data-id="element-942" />
      </main>
      <Footer data-id="element-943" />
    </div>;
}